<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/WHUD/WHUD.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">抬头显示器 W-HUD</div>
                <div class="detail-banner-desc">高亮度：亮度10000nit；<br />防阳光倒灌：可减少60%太阳反射能。</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            高亮度：亮度10000nit<br />
                        </div>
                        <div>
                            小体积：体积4L<br />
                        </div>
                        <div>
                            低成本：传动结构、PGU平台化开发<br />
                        </div>
                        <div>
                            防阳光倒灌：可减少60%太阳反射能
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/WHUD/WHUD-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">5.6° x 1.8°</div>
                                    <div class="k">视场角</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">VID 2.5m</div>
                                    <div class="k">投影距离</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">480*240</div>
                                    <div class="k">分辨率</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '抬头显示器 W-HUD - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/WHUD.html'
};

import { createApp } from 'vue';
import App from './WHUD.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./WHUD.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
